import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Timer from './Timer.js';
import './MagnetStrobeLayer.css';

import panel_strobe_1 from './assets/panel_strobe/P01.png';
import panel_strobe_2 from './assets/panel_strobe/P02.png';
import panel_strobe_3 from './assets/panel_strobe/P03.png';
import panel_strobe_4 from './assets/panel_strobe/P04.png';
import stage0_strobe1 from './assets/STAGE3strobe/S3_01.png';
import stage0_strobe2 from './assets/STAGE3strobe/S3_02.png';
import stage0_strobe3 from './assets/STAGE3strobe/S3_03.png';
import stage0_strobe4 from './assets/STAGE3strobe/S3_04.png';
import stage1_strobe1 from './assets/STAGE4strobe/S4_01.png';
import stage1_strobe2 from './assets/STAGE4strobe/S4_02.png';
import stage1_strobe3 from './assets/STAGE4strobe/S4_03.png';
import stage1_strobe4 from './assets/STAGE4strobe/S4_04.png';
import stage2_strobe1 from './assets/STAGE6strobe/S6_01.png';
import stage2_strobe2 from './assets/STAGE6strobe/S6_02.png';
import stage2_strobe3 from './assets/STAGE6strobe/S6_03.png';
import stage2_strobe4 from './assets/STAGE6strobe/S6_04.png';

const panel_strobes = [
  null,
  panel_strobe_1,
  panel_strobe_2,
  panel_strobe_3,
  panel_strobe_4,
];
const stage_strobes_by_level = [
  [
    null,
    stage0_strobe1,
    stage0_strobe2,
    stage0_strobe3,
    stage0_strobe4,
  ],
  [
    null,
    stage1_strobe1,
    stage1_strobe2,
    stage1_strobe3,
    stage1_strobe4,
  ],
  [
    null,
    stage2_strobe1,
    stage2_strobe2,
    stage2_strobe3,
    stage2_strobe4,
  ],
];

class MagnetStrobeLayer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			pulse_index: 0,
		};
	}

	render() {
		const {pulsing, level_index} = this.props;
		const {pulse_index} = this.state;

		if (!pulsing) {
			return null;
		}

		const timer = <Timer
			delay={340}
			on_timeout={() => {this.setState((old_state) => ({pulse_index: (old_state.pulse_index+1) % panel_strobes.length}))}}
			reset_prevention_key={pulse_index}
		/>

		if (!pulse_index) {
			return timer;
		}

		const stage_strobes = stage_strobes_by_level[level_index];
		return <div className="MagnetStrobeLayer">
			{timer}
			<img src={panel_strobes[pulse_index]} className="MagnetStrobeLayer" alt="" style={{
				left: 55,
				top: 45,
			}}/>
			<img src={stage_strobes[pulse_index]} className="MagnetStrobeLayer" alt="" />
		</div>
	}
}
MagnetStrobeLayer.propTypes = {
	level_index: PropTypes.number.isRequired,
	pulsing: PropTypes.bool.isRequired,
}

export default MagnetStrobeLayer;


// WEBPACK FOOTER //
// ./src/MagnetStrobeLayer.js